import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Route guard for /admin/* pages.
 * - Not authenticated → redirect to /account (login)
 * - Authenticated but not admin → redirect to / (home)
 * - Admin → render children
 *
 * `loading` stays true until both auth and the Customers.is_admin DB check
 * complete, so there is no flash-redirect for admin users on initial load.
 */
const AdminRoute = ({ children }) => {
  const { user, loading, isAdmin } = useAuth();

  if (loading) return <div className="admin-loading">Cargando...</div>;
  if (!user) return <Navigate to="/account" replace />;
  if (!isAdmin) return <Navigate to="/" replace />;

  return children;
};

export default AdminRoute;
